// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleMap_root__ot2Mj","mapViewIcon":"ToggleMap_mapViewIcon__1W0gb"};